// This is generated.  Alter it in blockGroups/filters/types/ByNavigationSelection.js
/* eslint-disable no-unused-vars */
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { namespace, relation } = hNode;
    //We know that the referenced namespace/relation must exist
    let subDataDictionary = {};
    //And the given foreignKey exists on the parent object.
    // This filter identifies a foreign key; its requiredness must come from a form.
    return [
      subDataDictionary,
      context.registerForeignKey(namespace, relation, []),
    ];
  },
};
moduleRegistration.registerHNodeType(
  'filters',
  'ByNavigationSelection',
  module.exports,
);
